import { ChangeEvent, ComponentPropsWithoutRef } from 'react';
import { CustomLabel, FakeRadio, Input, RadioTitle } from '@/components/form/fields/RadioGroup/styles';

type RadioFieldType = {
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
} & ComponentPropsWithoutRef<'input'>;

export const RadioField = ({ label, disabled = false, checked, onChange, value, ...rest }: RadioFieldType) => {
  return (
    <CustomLabel disabled={disabled}>
      <Input type='radio' checked={checked} onChange={onChange} disabled={disabled} value={value} {...rest} />
      <FakeRadio disabled={disabled} />
      {label && <RadioTitle isActive>{label}</RadioTitle>}
    </CustomLabel>
  );
};
